export default 'M10.56 14.06a1.5 1.5 0 0 0 0-2.12L6.62 8l3.94-3.94a1.5 1.5 0 0 0-2.12-2.12l-5 5a1.5 1.5 0 0 0 0 2.12l5 5a1.5 1.5 0 0 0 2.12 0';